import { Button, Menu, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { AddNewNode, NodeList } from '../ManageNodes';
import AddUser from '../AddUser';
import UserList from '../UserList';
import AddTemplate from '../AddTemplate';
import TemplateList from '../TemplateList';
import AddTemplateOodocs from '../AddTemplateOodocs';
import TemplateListOodocs from '../TemplateListOodocs';
import AddCenter from '../AddCenter';
import CenterList from '../CenterList';
import StatsDashboard from '../StatsDashboard';
import CenterAnalytics from '../CenterAnalytics';
import ReportHeaderConfig from './ReportHeaderConfig';
import ShortcutsAdmin from '../ShortcutsAdmin';
import SessionManagement from '../SessionManagement';
import PricingList from '../PricingList';
import AddPricing from '../AddPricing';
import CostReports from '../CostReports';
import AcademicsPage from '../academics';
import { NavigationItems } from './constants';
import './settings.css';

const Settings = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState('analytics_dashboard');

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const onNavChange = (item) => {
    console.log('onNavChange', item);
    setSelectedMenu(item.key);
  };

  const menuToPage = {
    analytics_dashboard: <StatsDashboard />,
    center_analytics: <CenterAnalytics />,
    nodes_list: <NodeList />,
    add_node: <AddNewNode />,
    users_list: <UserList />,
    add_user: <AddUser />,
    templates_list: <TemplateList />,
    add_template: <AddTemplate />,
    oo_templates_list: <TemplateListOodocs />,
    oo_add_template: <AddTemplateOodocs />,
    centers_list: <CenterList />,
    add_center: <AddCenter />,
    report_header_config: <ReportHeaderConfig />,
    shortcuts_admin: <ShortcutsAdmin />,
    session_management: <SessionManagement />,
    pricing_list: <PricingList />,
    add_pricing: <AddPricing />,
    cost_reports: <CostReports />,
    academics: <AcademicsPage />,
  };

  return (
    <div className="settings-container h-100">
      <div className="d-flex h-100">
        <div className={`side-menu ${collapsed ? 'collapsed' : ''}`}>
          {/* <Tooltip title={collapsed ? 'Expand' : 'Collapse'}>
            <Button
              type="primary"
              className="toggle-btn"
              onClick={toggleCollapsed}
              style={{ marginBottom: 16 }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
          </Tooltip> */}
          <Menu
            defaultSelectedKeys={[selectedMenu]}
            defaultOpenKeys={['analytics', 'users', 'templates', 'oo_templates', 'centers', 'library', ...(window.ENV_CONFIG?.ENABLE_SESSION_TRACKING ? ['security'] : []), ...(window.ENV_CONFIG?.ENABLE_CENTRE_BILLING ? ['billing'] : [])]}
            mode="inline"
            inlineCollapsed={collapsed}
            items={NavigationItems(onNavChange)}
            onClick={onNavChange}
          />
        </div>
        <div className="flex-1 content-area overflow-auto">
          {menuToPage[selectedMenu]}
        </div>
      </div>
    </div>
  );
};

export default Settings;
